<template>
  <div style="background-color: #f1f1f1; padding-top: 100px;">
    <el-row>
      <el-col :span="20" :offset="2">
        <el-card style="height: auto;">
          <template v-for="(item, index) in funList">
            <el-button
              v-bind:key="index"
              type="info"
              style="margin: 10px;"
              class="btn"
              @click="showDetail(item)"
              >{{ item.title }}
            </el-button>
          </template>
        </el-card>
      </el-col>
    </el-row>

    <div
      style="margin-top: 2em; padding-top: 2em; padding-bottom: 2em; background-color: #f1f1f1;"
    >
      <el-row>
        <el-col :span="10" :offset="0" style="text-align: center;">
          <img
            v-if="funInfo.img"
            width="60%"
            class="top-img box-info"
            :src="
              require('../../../assets/images/module/' + funInfo.img + '.png')
            "
          />
        </el-col>
        <el-col :span="12">
          <el-card class="box-info">
            <div class="titleCss">
              <img src="@/assets/images/title.png" />
              <h1>{{ funInfo.title }}</h1>
            </div>
            <div class="content">
              <p class="t">{{ funInfo.t1 }}</p>
              <p class="c">{{ funInfo.c1 }}</p>
              <p class="t">{{ funInfo.t2 }}</p>
              <p class="c">{{ funInfo.c2 }}</p>
              <p class="t">{{ funInfo.t3 }}</p>
              <p class="c">{{ funInfo.c3 }}</p>
              <p class="t">{{ funInfo.t4 }}</p>
              <p class="c">{{ funInfo.c4 }}</p>
              <p class="t">{{ funInfo.t5 }}</p>
              <p class="c">{{ funInfo.c5 }}</p>
            </div>
          </el-card>
        </el-col>
        <el-col
          :span="20"
          :offset="2"
          style="text-align: center; margin-top: 40px;"
          v-if="funInfo.img1"
        >
          <el-card class="box-info">
            <h1>{{ funInfo.img1Title }}</h1>
            <img
              width="100%"
              class="top-img box-info"
              :src="
                require('../../../assets/images/module/' +
                  funInfo.img1 +
                  '.png')
              "
            />
            <img
              v-if="funInfo.img2"
              width="100%"
              class="top-img box-info"
              style="margin-top: 40px;"
              :src="
                require('../../../assets/images/module/' +
                  funInfo.img2 +
                  '.png')
              "
            />
            <img
              v-if="funInfo.img3"
              width="100%"
              class="top-img box-info"
              style="margin-top: 40px;"
              :src="
                require('../../../assets/images/module/' +
                  funInfo.img3 +
                  '.png')
              "
            />
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { device, quality, user, products } from "@/js/infoData.js";

export default {
  name: "ModuleDetailAll",
  props: {
    itemData: {}
  },
  data() {
    return {
      // products: [],
      show: 0,
      activeTab: "0",
      // 菜单list
      funList: [],
      funInfo: {}
    };
  },
  mounted() {
    this.init();
    // this.products = products;
  },
  methods: {
    init() {
      this.activeTab = "0";
      this.handleClickTab();
    },
    handleClickTab() {
      this.funList = [];
      this.products = products;
      products.type.forEach(element => {
        this.funList.push(element);
      });
      this.showDetail(0);
      // debugger;
      // if (this.activeTab == 0) {
      //   device.forEach(element => {
      //     this.funList.push(element);
      //   });
      // } else if (this.activeTab == 1) {
      //   quality.forEach(element => {
      //     this.funList.push(element);
      //   });
      // } else if (this.activeTab == 2) {
      //   user.forEach(element => {
      //     this.funList.push(element);
      //   });
      // }
    },

    showDetail(item) {
      if (item == 0) {
        item = this.funList[0];
        // item = this.products.type[0];
        // this.show = true;
      }
      this.funInfo = item;
      console.log(this.funInfo);
    }
    // didSelect(ids) {
    //   // 取消先进先出响应
    //   if (ids === 3) {
    //     return;
    //   }
    //   this.show = ids;
    // },
    // linkClass(idx) {
    //   if (this.show === idx) {
    //     return ["label-did"];
    //   } else {
    //     return ["label"];
    //   }
    // }
  }
};
</script>

<style lang="stylus">
.el-button {
  width: 120px;
}

.el-tabs__item {
  font-size: 25px;
}
</style>
<style lang="stylus" scoped>
.el-tabs__item {
  font-size: 25px;
}

.titleCss {
  position: relative;

  img {
    position: absolute;
    height: 50px;
  }

  h1 {
    position: absolute;
    color: #ffffff;
    line-height: 50px;
  }
}

.content {
  p:first-child {
    margin-top: 63px;
  }

  .t {
    font-size: 23px;
  }

  .c {
    font-size: 18px;
  }
}

.box-info {
  height: 100%;
}

.box {
  width: 60%;
  height: auto;
  margin-left: auto;
  margin-right: auto;

  .btn {
    width: 120px;
    margin-left: 0px;
    font-size: 18px;
  }
}

.funs {
  width: 100%;
}

.b-tabs {
  box-shadow: 0rem 0.3rem 0.8rem 0rem rgba(2, 0, 0, 0.11);
  padding-top: 2rem;
  padding-bottom: 2rem;
}

.label-did {
  color: #12b7f6;
  font-size: 1.3rem;
}

.label {
  color: #999999;
  font-size: 1.3rem;
}

.div-content {
  margin-top: 5rem;
  width: 100%;

  .top-img {
    width: 100%;
  }

  .p-title {
    margin-top: 4rem;
    font-size: 1.5rem;
    color: #333333;
  }

  .p-title-bg {
    margin-top: -6rem;
    margin-left: 50%;
    transform: translateX(-50%);
  }

  .p-desc {
    margin-top: 2rem;
    fontsize: 1.1rem;
    color: #333333;
  }
}

.footer-img {
  width: 100%;
  margin-top: 5rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/module/components/ModuleDetailAll.vue